<template>
  <div style="width:100%" class="vertical-center-box">
    <el-select class="mr-r4" :style="!disabled ? 'width:calc(100% - 34px);' : 'width:100%;'" v-model="objCompanyId" :disabled="disabled" autocomplete filterable>
      <el-option v-for="item in vendorList" :key="item.objCompanyId" :label="item.objCompanyName" :value="item.objCompanyId"></el-option>
    </el-select>
    <el-button v-if="!disabled" size="mini" type="content" icon="fas fa-search" @click="openVendorPopup"></el-button>
    <w-vendor-sliding-popup ref="vendorSlidingPopup" @apply-vendor="onApplyVendor"/>
  </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import cloneDeep from 'lodash/cloneDeep';
import findIndex from 'lodash/findIndex';
import NetdeviceSettingAPI from '@/api/settings/netdevice/netdevice-settings';
import WVendorSlidingPopup from '@/views/settings/components/popup/VendorSlidingPopup';

export default {
  name: 'WVendorCombobox',
  components: {
    WVendorSlidingPopup,
  },
  props: {
    editRow: Object,
    disabled: Boolean,
  },
  data() {
    return {
      objCompanyId: null,
      vendorList: [],
    };
  },
  created() {
    this.loadData();
  },
  watch: {
    editRow: {
      immediate: true,
      handler() {
        if (this.editRow && !isNil(this.editRow.objCompanyId)) {
          this.objCompanyId = this.editRow.objCompanyId; // 선택된 벤더 정보 설정
          this.addVendor(this.editRow);
        }
      },
    },
    objCompanyId: {
      immediate: true,
      handler(to) {
        if (!isNil(to) && this.vendorList.length > 0) { // 벤더 변경 시 변경된 벤더 정보와 함께 change 이벤트 emit
          const index = findIndex(this.vendorList, (item) => item.objCompanyId === to);
          let vendor;
          if (index >= 0) {
            vendor = this.vendorList[index];
          } else {
            vendor = null;
          }
          this.$emit('change', vendor);
        } else {
          this.$emit('change', null);
        }
      },
    },
  },
  methods: {
    /**
     * 벤더 정보를 로드한다.
     * @author Ju
     */
    loadData() {
      NetdeviceSettingAPI.getVendorInfoList({ showFlag: 'Y' }).then((result) => {
        if (result.data.success) {
          this.vendorList = result.data.data;
          if (isNil(this.editRow.objCompanyId)) {
            this.objCompanyId = result.data.data[0].objCompanyId;
          }
        }
      });
    },
    /**
     * 벤더 팝업에서 선택한 벤더를 콤보박스에 설정한다.
     * @author Ju
     * @param  {[type]} data [description]
     */
    onApplyVendor(data) {
      this.addVendor(data);
      this.objCompanyId = data.objCompanyId;
    },
    addVendor(data) {
      if (findIndex(this.vendorList, (item) => item.objCompanyId === data.objCompanyId) < 0) {
        const vendorList = cloneDeep(this.vendorList);
        vendorList.push(data);
        this.vendorList = vendorList;
      }
    },
    /**
     * 벤더 팝업을 연다
     * @author Ju
     */
    openVendorPopup() {
      this.$refs.vendorSlidingPopup.open();
    },
    /**
     * 벤더 콤보박스의 값을 지운다.
     * @author Ju
     */
    clear() {
      this.objCompanyId = null;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/netdevice/OidSettings/VendorModelOidSettings/component/VendorCombobox.vue